/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { SelectEducationValues } from './selectEducationModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'select-education-modal',
    standalone: false,
})
export class SelectEducationModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Output() dismiss: EventEmitter<void>;
    @Input() resolve: SelectEducationValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('selectEducationModal', elementRef, injector);
    }
}
